import axiosInstance from '../../utils/axiosInstance';
import { Partner, CreatePartnerRequest } from '../../model/Partner.model';

class PartnerService {
  private readonly baseURL = '/partners';

  async getAllPartners(): Promise<Partner[]> {
    const { data } = await axiosInstance.get(this.baseURL);
    return data;
  }

  async getPartnerById(id: number): Promise<Partner> {
    const { data } = await axiosInstance.get(`${this.baseURL}/${id}`);
    return data;
  }

  async createPartner(partner: CreatePartnerRequest): Promise<Partner> {
    const { data } = await axiosInstance.post(
      `${this.baseURL}/create`,
      partner
    );
    return data;
  }

  async updatePartner(
    id: number,
    partner: CreatePartnerRequest
  ): Promise<Partner> {
    const { data } = await axiosInstance.put(
      `${this.baseURL}/edit/${id}`,
      partner
    );
    return data;
  }

  async deletePartner(id: number): Promise<void> {
    await axiosInstance.delete(`${this.baseURL}/delete/${id}`);
  }
}

export default new PartnerService();
